import { useCommonContext } from "../../../contexts/common";
import { DownloadIcon } from "@primer/octicons-react";
import { Box, IconButton } from "@primer/react";
import ExcelJS from "exceljs";
import React, { useContext } from "react";
import Text from "../../text";

import {
  DataGridContainerContext,
  IDataGridContainerContext,
} from "../DataGrid";
import {
  GetDataGridHederGroupCell,
  renderExcelHeader,
} from "../type/ColumnHelper";
import { IDataGridColumn, IExportConfig } from "../type/IDataGridProps";
interface ITittleProps {
  title?: string | React.ReactNode;
}
interface ISubTittleProps {
  subTitle?: string | React.ReactNode;
}
interface IActionsProps {
  actionComponent?: React.ReactNode;
  searchEnable?: boolean;
  columns: IDataGridColumn[];
  onSearchKeyChanged: (value: string) => void;
  exportConfig?: IExportConfig;
  filterdData: any[];
  dataColumns: IDataGridColumn[];
}
interface IToolbarProps {
  onSearchKeyChanged: (value: string) => void;
  filterdData: any[];
  dataColumns: IDataGridColumn[];
}
const Toolbar = (props: IToolbarProps) => {
  const { onSearchKeyChanged, filterdData } = props;
  const {
    title,
    subTitle,
    actionComponent,
    searchEnable,
    columns,
    exportConfig,
  } = useContext<IDataGridContainerContext>(DataGridContainerContext);

  return (
    <Box sx={{ display: "grid", gap: 1 }}>
      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
        <Box sx={{ flex: 1, display: "grid", gap: 1, minWidth: "200px" }}>
          <Tittle title={title} />
          <SubTittle subTitle={subTitle} />
        </Box>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Actions
            actionComponent={actionComponent}
            searchEnable={searchEnable}
            columns={columns}
            onSearchKeyChanged={onSearchKeyChanged}
            filterdData={filterdData}
            exportConfig={exportConfig}
            dataColumns={props.dataColumns}
          />
        </Box>
      </Box>
    </Box>
  );
};
const Tittle = React.memo((props: ITittleProps) => {
  const { title } = props;
  if (!title) return null;
  if (typeof title === "string") {
    return (
      <Text
        text={title as string}
        sx={{
          fontWeight: "bolder",
          fontSize: 24,
        }}
      />
    );
  }
  return <>{props.title}</>;
});
const SubTittle = React.memo((props: ISubTittleProps) => {
  const { subTitle } = props;
  if (!subTitle) return null;
  if (typeof subTitle === "string") {
    return (
      <Text
        text={subTitle as string}
        sx={{
          color: "fg.muted",
        }}
      />
    );
  }
  return <>{props.subTitle}</>;
});
const Actions = React.memo((props: IActionsProps) => {
  const {
    actionComponent,
    searchEnable,
    exportConfig,
    columns,
    filterdData,
    dataColumns,
  } = props;
  const { translate } = useCommonContext();
  const handleExportAsync = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");
    const headerGroups = GetDataGridHederGroupCell(columns);
    console.log({
      headerGroups,
    });
    renderExcelHeader(worksheet, headerGroups);

    const dataStartRow = headerGroups.length + 1;
    dataColumns
      .filter((x) => x.id !== "col_idx" && x.id !== "selection")
      .forEach((col, idx) => {
        worksheet.getColumn(idx + 1).width = col.width ? col.width / 10 : 10;
      });

    // Clone data để không ảnh hưởng đến data gốc
    let exportData = [...filterdData];

    // Gọi customizeExportData nếu được định nghĩa
    if (exportConfig?.customizeExportData) {
      const options = { rows: exportData.map((data) => ({ data })) };
      exportConfig.customizeExportData(options);
      exportData = options.rows.map((row: any) => row.data);
    }

    exportData.forEach((item) => {
      const rowValues = dataColumns
        .filter((x) => x.id !== "col_idx" && x.id !== "selection")
        .map((col) => (col.dataField ? item[col.dataField] : ""));
      worksheet.addRow(rowValues);
    });
    worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
      for (let col = 1; col <= worksheet.columnCount; col++) {
        const cell = row.getCell(col);

        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        if (rowNumber < dataStartRow) {
          cell.font = { bold: true };
        }
      }
    });

    // Xuất file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${exportConfig?.fileName ?? "Download"}.xlsx`;
    link.click();
  };
  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
      }}
    >
      {actionComponent}
      {exportConfig?.enable && (
        <>
          {!exportConfig?.render && <IconButton
            icon={DownloadIcon}
            variant="default"
            aria-label="Download"
            onClick={() => {
              if (props.exportConfig?.onExportClick) {
                props.exportConfig?.onExportClick();
              } else {
                handleExportAsync();
              }
            }}
          />}
          {exportConfig?.render &&
            <Box
              onClick={() => {
                if (props.exportConfig?.onExportClick) {
                  props.exportConfig?.onExportClick();
                } else {
                  handleExportAsync();
                }
              }}
              sx={{ cursor: "pointer" }}
            >
              {exportConfig?.render()}
            </Box>
          }
        </>
      )}
    </Box>
  );
});
export default Toolbar;
